<template>
  <div  class="row">
    <div v-if="allOrders.length <= 0" class="col-12  text-center">
      <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
      <div class="mt-2">
        سفارشی موجود نیست
      </div>

    </div>
    <div v-else class="col-12">
      <div class="row">
        <div class="col ">
          <v-text-field
              append-icon="far fa-magnifying-glass"
              class="rounded-lg"
              dense
              flat
              v-model="searchKeyWord"
              hide-details
              placeholder=" کد پیگیری"
              solo
              @keyup="search"
              clearable
              @click:clear="removeSearchHistory">
          </v-text-field>
        </div>
        <div v-if="!hasResult" class="col-12 text-center">
          نتیجه ای یافت نشد
        </div>
        <div v-else v-for="(item,i) in allOrders" :key="i" class="col-12">
          <div class="rounded-lg bg-white row p-1 py-2">
            <div class="col-12 font-weight-bold">{{ i + 1 }}</div>
            <div class="col-6 py-1 font-weight-bold">کد پیگیری</div>
            <div class="col-6 py-1 text-left font-weight-bold">{{ item.TrackingCode }}</div>
            <div class="col-6 py-1 font-weight-bold">تاریخ سفارش</div>
            <div class="font-weight-bold col-6 py-1 text-left">{{ $convertDate(item.ModifiedDate) }}</div>
            <div class="font-weight-bold col-6 py-1">روش پرداخت</div>
            <div class="font-weight-bold col-6 py-1 text-left">{{ $TypePayment(item.TypePayment) }}</div>
            <div class="font-weight-bold col-6">نام فروشگاه</div>
            <div class="font-weight-bold col-6 text-left">{{ item.VendorName }}</div>
            <div class="font-weight-bold col-12 py-1 pointer" @click="seeData(item.VendorInvoiceID)"><i
                class="fa-regular fa-user fa-lg ml-2"></i> مشاهده اطلاعات خریدار
            </div>
            <div class="font-weight-bold col-12 py-1 pointer" @click="seeFactor(item.VendorInvoiceID)"><i
                class="fa-regular fa-file-lines fa-lg ml-2 "></i> مشاهده فاکتور خرید
            </div>
            <div class="font-weight-bold col-12 py-1 pointer" @click="seeAddress(item.VendorInvoiceID)"><i
                class="fa-regular fa-circle-info fa-lg ml-2"></i> مشاهده آدرس تحویل و تحویل گیرنده
            </div>
            <div class="font-weight-bold col-12 py-1 pointer" @click="openChangeStatusModal(item.VendorInvoiceID)"><i
                class="fa-regular fa-shuffle fa-lg ml-2"></i>تغییر وضعیت سفارش
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
    <v-bottom-sheet v-model="openBottomSheet" class="bottom-sheet" width="600">
      <v-sheet
          class="rounded-t-xl">
        <div class="row no-gutters align-items-center">
          <div class="col pr-5 py-2 toggle-filter-btn">
            {{ bottomSheetTitle }}
          </div>
          <div class="col text-left pl-4">
            <v-btn
                icon
                @click="openBottomSheet = !openBottomSheet">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row mx-2">
          <div class="col-12">
            <div v-html="bottomSheetText">

            </div>
          </div>
        </div>

      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openBottomSheetChangeStatus" class="bottom-sheet" width="600">
      <v-sheet
          class="rounded-t-xl">
        <div class="row no-gutters align-items-center">
          <div class="col pr-5 py-2 toggle-filter-btn">
           تغییر وضعیت سفارش
          </div>
          <div class="col text-left pl-4">
            <v-btn
                icon
                @click="openBottomSheetChangeStatus = !openBottomSheetChangeStatus">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row mx-2">
          <div class="col-12 mt-5">
            <v-select
                v-model="typeStatus"
                :items="items"
                class="edit-profile-input"
                dense
                background-color="secondary"
                flat
                hide-details
                item-value="id"
                solo></v-select>
          </div>
          <div class="col-12 text-left">
            <v-btn
                class="px-10"
                color="primary"
                depressed
                @click="changeStatus">
              انجام
            </v-btn>
          </div>
        </div>

      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openBottomSheetFactorDetail" class="bottom-sheet" scrollable>
      <v-sheet
          class="rounded-t-xl rounded-t-xl overflow-y-auto overflow-x-hidden">
        <div class="row no-gutters align-items-center">
          <div class="col pr-5 py-2 toggle-filter-btn">
            فاکتور خرید
          </div>
          <div class="col text-left pl-4">
            <v-btn
                icon
                @click="openBottomSheetFactorDetail = !openBottomSheetFactorDetail">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="my-3 text-center" v-html="factorTitle"></div>
        <div style="overflow: auto">
          <v-data-table
              :headers="headers"
              :items="detailOrder"
              :items-per-page="5"
              :light="true"
              :mobile-breakpoint="680"
              class="data-table"
              fixed-header>

            <template v-slot:[`item.FileUrl`]="{ item }">
              <div class="p-2">
                <v-img :src="$replaceHttps(item.FileUrl)"
                       :lazy-src="$replaceHttps(item.FileUrl)"
                       height="150"
                       width="150">
                </v-img>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: "SellerCartCard",
  props:['orders'],
  data: function () {
    return {
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    bottomSheetTitle: '',
    bottomSheetText: '',
    openBottomSheet: false,
    openBottomSheetFactorDetail: false,
    factorTitle: null,
    detailOrder: [],
    headers: [
      {text: 'محصول', value: 'Name'},
      {text: 'تخفیف', value: 'Discount'},
      {text: 'عکس', value: 'FileUrl', sortable: false,},
      {text: 'تعداد سفارش', value: 'NumberNeed'},
      {text: ' مجموع ردیف', value: 'TotalRow'},
      {text: 'فروشنده', value: 'VendorName'},
    ],
    items: [
      {id: 1, text: 'ثبت سفارش'},
      {id: 2, text: 'تایید سفارش'},
      {id: 3, text: 'تحویل سفارش'},
      {id: 4, text: 'لغو سفارش'},
    ],
    typeStatus:null,
    vendorId:null,
    openBottomSheetChangeStatus:false,
    allOrders:[],
    searchKeyWord:'',
    hasResult:true,
    isLoaded:false,

  }},
  mounted() {
    this.allOrders= this.orders
  },

  methods: {
    seeData(id) {
      this.showLoaderDialog = true
      this.bottomSheetText = 'اطلاعات خریدار';
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorInvoiceID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/InvoiceReportManagement/_ShowClientInfoInvoice", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog=false
            this.openBottomSheet = true;
            this.bottomSheetText =result
          })
          .catch(error => console.log('error', error));

    },
    seeFactor(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorInvoiceID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/InvoiceReportManagement/_DetailsInvoice", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog=false
            let json = JSON.parse(result)
            this.factorTitle = json.Factor
            this.detailOrder = json.list
            this.openBottomSheetFactorDetail = true

          })
          .catch(error => console.log('error', error));
    },
    seeAddress(id) {
      this.showLoaderDialog= true
      this.bottomSheetTitle = 'آدرس'
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorInvoiceID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/InvoiceReportManagement/_ShowAddress", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog=false
            this.bottomSheetText = result
            this.openBottomSheet = true
          })
          .catch(error => console.log('error', error));
    },
    openChangeStatusModal(id) {
      this.vendorId = id;
      this.openBottomSheetChangeStatus = true
    },
    changeStatus(){
      this.openBottomSheetChangeStatus = false
      this.showLoaderDialog= true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorInvoiceID", this.vendorId);
      urlencoded.append("TypeInvoiceStatus", this.typeStatus);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/InvoiceReportManagement/_ChangeStatusInvoice", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog=false
            this.resultText=result
            this.showResult= true
            location.reload()

          })
          .catch(error => console.log('error', error));
    },
    removeSearchHistory() {
      this.allOrders = this.orders
      this.hasResult = true
    },
    search() {
      let result = this.orders.filter(x => x.TrackingCode.includes(this.searchKeyWord));
      if (this.searchKeyWord === '') {
        this.allOrders = this.orders
      } else {
        if (result.length === 0) {
          this.hasResult = false
        } else {
          this.hasResult = true
          this.allOrders= result
        }
      }
    },

  }
}
</script>

<style scoped>

</style>
